module.exports = __webpack_public_path__ + "static/media/storePurchase_30_35.250aafcf.png";